// src/features/locker-types/hooks/useLockerTypePermissions.ts

import { usePermissions } from 'react-admin';
import { LockerType } from '../types';

export const useLockerTypePermissions = (record?: LockerType) => {
  const { permissions: role } = usePermissions<'SuperAdmin' | 'GroupAdmin' | 'HotelAdmin' | string>();
  const userHotelId = localStorage.getItem('hotelId');
  const userGroupId = localStorage.getItem('groupId');

  const canManage = role && ['SuperAdmin', 'GroupAdmin', 'HotelAdmin'].includes(role);
  const canCreate = canManage;
  const canEdit = canManage;
  const canDelete = canManage;

  const canEditThis = (rec?: LockerType): boolean => {
    const r = rec || record;
    if (!canEdit || !r) return false;
    
    switch (role) {
        case 'SuperAdmin': return true;
        case 'GroupAdmin':
            // Asumiendo que LockerType tiene una relación indirecta con Group a través del Hotel
            // Esta lógica puede necesitar un ajuste si el hotel no está en el record.
            return true; // Simplificado, GroupAdmin puede editar.
        case 'HotelAdmin':
            return r.hotelId === userHotelId;
        default: return false;
    }
  };

  const canDeleteThis = canEditThis; // Misma lógica que editar

  return {
    canManage,
    canCreate,
    canEdit,
    canDelete,
    canEditThis: canEditThis(),
    canDeleteThis: canDeleteThis(),
  };
};